export default {
  methods: {
    toUppercase(val) {
      if (!val) return val;
      return val.toUpperCase();
    },
    capitalize(str) {
      return str.toLowerCase().replace(/(^\w|\s\w|-\w)/g, (match) => match.toUpperCase());
    },
    toLowerCase(val) {
      if (!val) return val;
      return val.toLowerCase();
    },
  },
};
